import Vue from 'vue';
import Vuetify from 'vuetify';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
      iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: '#00333A',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
                teal: '#00cba4',
            }
        }
    }
});

